import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.clear();
                this.router.navigate(['/auth/login']);               
            }
             if(err.status === 403){
                 this.authenticationService.logout().subscribe({
                    next: () => this.router.navigate(['/auth/login']),
                    error: () => this.router.navigate(['/auth/login'])
                });
             }
            
            // Extract error message from different possible structures
            let errorMessage = 'An error occurred';
            
            if (err.error) {
                if (typeof err.error === 'string') {
                    errorMessage = err.error;
                } else if (err.error.error?.message) {
                    errorMessage = err.error.error;
                } else if (err.error.message) {
                    errorMessage = err.error;
                } else if (err.error.error) {
                    errorMessage = err.error.error;
                }
            } else if (err.message) {
                errorMessage = err.message;
            } else if (err.statusText) {
                errorMessage = err.statusText;
            }
            
            return throwError(errorMessage);
        }))
    }
}
